// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"4720d27f","453":"01268e98"}[chunkId] + ".chunk.js";
};